import React, { memo } from "react";
//interfaces
import { ICheckboxInputProps } from "./interface";
//style
import { Container } from "./styles";

const Checkbox = memo((props: ICheckboxInputProps) => {
  const { id, children, checked, onChange, classname, title, ...rest } = props;

  return (
    <Container id={`LABEL_${id}`}>
      <input
        type="checkbox"
        title={title || ""}
        checked={checked}
        onChange={onChange}
        id={id}
        {...rest}
      />
      <div className="checkmark">
        <div className={checked ? "checked" : ""} />
      </div>

      {children}
    </Container>
  );
});

export { Checkbox };
